import radish from './src/radish'
import radishList from './src/radish-list'
import radishListMatch from './src/radish-list-match'
import radishListSimple from './src/radish-list-simple'
import radishListPro from './src/radish-list-pro'
import radishListOnekey from './src/radish-list-onekey.vue'
import radishAdd from './src/radish-add'
import radishAddPage from './src/radish-add-page'
import radishQuickAdd from './src/radish-quick-add'
import radishSimpleAdd from './src/radish-simple-add'
import radishDetail from './src/radish-detail'
import radishDetailTab from './src/radish-detail-tab'
import radishCvUpload from './src/radish-cv-upload-new'
import radishExcelUpload from './src/excel/radish-excel-upload'
import aTable from './src/table/a-table'
import radishProDialog from './src/dialog/pro-dialog'
import orderDialog from './src/dialog/order-dialog'
import simiDialog from './src/dialog/simi-dialog-v2'
import offerDialog from './src/dialog/offer-dialog'
import toworkDialog from './src/dialog/towork-dialog'
import yejiDialog from './src/dialog/yeji-dialog'
import caseDialog from './src/dialog/case-dialog'
import radishLeft from './src/radish-left'
import radishDup from './src/radish-dup'
import tmpRadish from './src/tmp-radish'
import radishEditCompany from './src/dialog/edit-company-dialog'
import tagCompletion from './src/tag-completion'
import logList from './src/log-list'
import proSelectDialog from './src/dialog/pro-select-dialog'
import favDialog from './src/dialog/fav-dialog'
import formItem from './src/components/form-item'
import ExcelCorrection from './src/excel/excel-correction'
import DupList from './src/excel/dup-list'
import DupDetail from './src/excel/dup-detail'
import ManagerList from './src/components/manager-list'
import RadishPortrait from './src/radish-portrait'
import makePayDoc from './src/components/make-paydoc.vue'
import makePayDocTmpl from './src/components/make-paydoc-template.vue'
import Loading from './src/components/loading.vue'

export {
  radish,
  radishList,
  radishListPro,
  radishListOnekey,
  radishAdd,
  radishQuickAdd,
  radishSimpleAdd,
  radishDetail,
  radishDetailTab,
  radishCvUpload,
  radishExcelUpload,
  aTable,
  radishProDialog,
  radishLeft,
  radishDup,
  tmpRadish,
  radishEditCompany,
  orderDialog,
  offerDialog,
  toworkDialog,
  tagCompletion,
  simiDialog,
  radishAddPage,
  radishListSimple,
  radishListMatch,
  logList,
  proSelectDialog,
  favDialog,
  formItem,
  ExcelCorrection,
  DupList,
  DupDetail,
  ManagerList,
  yejiDialog,
  caseDialog,
  RadishPortrait,
  makePayDoc,
  makePayDocTmpl,
  Loading,
}
